export const MODALS = {
	BREAKDOWN: 'PRICE_BREAKDOWN',
	CANCEL_TERMS: 'CANCELLATION_POLICY',
	TERMS: 'TERMS_AND_CONDITIONS',
	CANCEL_RES: 'CANCEL_RESERVATION',
};

export const INPUT_TYPES = {
	BUTTON_OPTIONS: 'BUTTON_OPTIONS',
	CARD_EXPIRY_DATE: 'CARD_EXPIRY_DATE',
	CARD_NUMBER: 'CARD_NUMBER',
	CHECKBOX: 'CHECKBOX',
	DATE: 'DATE',
	DATE_PICKER: 'DATE_PICKER',
	DROPDOWN: 'DROPDOWN',
	EMAIL: 'EMAIL',
	NUMBER: 'NUMBER',
	PHONE: 'PHONE',
	RADIO: 'RADIO',
	TEXT: 'TEXT',
	TEXTAREA: 'TEXTAREA',
	TIME: 'TIME',
	HIDDEN: 'HIDDEN',
};

// Use type to get the type of the constant and very often, you'll also want this type, which is a union of its string values
export type InputTypeValue = (typeof INPUT_TYPES)[keyof typeof INPUT_TYPES];

export const PRODUCT_SECTIONS = {
	TRANSPORTATION: 'Transportation',
	DEPARTURE_TRANSPORTATION: 'Departure Transportation',
	ARRIVAL_AMENITIES: 'Arrival Amenities',
	SPA: 'spa',

	// the following need to be confirmed
	EXPERIENCES: 'experiences',
	FOOD_AND_BEVERAGE: 'foodAndBeverage',
};
